import requestHandler from 'shared/utils/request-handler';
import {IGetAllTokenBalanceResponse} from './token-balance.dto';

const BASE_URL = '/api/v1/TokenBalance';


export const GETGetAllTokenBalance = async () => {
	return requestHandler.call<IGetAllTokenBalanceResponse[]>({ url: `${BASE_URL}/GetAll?hasValue=false`, method: 'get' }).then(res => res.data);
};
